import { useNotificationStore } from "@stores/notification.store";
import { useThemeStore } from "@stores/theme.store";

import moment from "moment";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const DeliveryDataDetailPage = () => {
  const { state } = useLocation();
  const { setFooter, setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setFooter(false);
    setHeader({
      type: "small",
      title: "Detail Pengiriman",
      buttonBack: true,
      avatar: true,
    });
    setAppBar({ title: "Detail Pengiriman", leading: "back" });
  }, [setFooter, setHeader, setAppBar]);

  return (
    <>
      <div className="card card-style">
        <div className="content d-flex flex-column mb-0">
          <div className="color-highlight">Status Barang</div>
          <div className="color-theme mb-3">
            {state.selesai === "Y"
              ? "Sudah Diserahkan ke Siswa"
              : state.selesai === "N"
              ? "Belum Diserahkan ke Siswa"
              : "-"}
          </div>
          <div className="color-highlight">Tanggal Datang</div>
          <div className="color-theme mb-3">
            {moment(state.tanggal_datang ?? Date.now()).format(
              "dddd, DD MMMM YYYY | HH:mm"
            )}
          </div>
          {/* <div className="color-highlight">Tanggal Kembali</div>
        <div className="color-theme mb-3">
          {moment(state.dateBack ?? Date.now()).format(
            "dddd, DD MMMM YYYY, HH:mm"
          )}
        </div> */}
          <div className="color-highlight">Isi Paket</div>
          <div className="color-theme mb-3">{state.isi_paket ?? "-"}</div>
          <div className="color-highlight">Pengirim</div>
          <div className="color-theme mb-3">{state.pengirim ?? "-"}</div>
          {/* <div className="color-highlight">Waktu Izin</div>
        <div className="color-theme mb-3">{state.time ?? '-'}</div> */}
          <div className="color-highlight">Petugas Penerima</div>
          <div className="color-theme mb-3">{state.nama ?? "-"}</div>

          <div className="color-highlight">Perusahaan Logistik</div>
          <div className="color-theme mb-3">{state.logistik ?? "-"}</div>

          {state.selesai === "Y" && (
            <>
              <div className="color-highlight">Status Pengiriman</div>
              <div className="color-theme mb-3">Selesai</div>

              <div className="color-highlight">Petugas Pengantar</div>
              <div className="color-theme mb-3">
                {state.petugas_pengantar ?? "-"}
              </div>

              <div className="color-highlight">Tanggal Diserahkan</div>
              <div className="color-theme mb-3">
                {moment(state.tanggal_penyerahan ?? Date.now()).format(
                  "dddd, DD MMMM YYYY | HH:mm"
                )}
              </div>

              <div className="color-highlight">Catatan Selesai</div>
              <div className="color-theme mb-3">
                {state.catatan_selesai ?? "-"}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};
